import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import postStoreOrderDelivered from './postStoreOrderDelivered';

export interface IPostStoreOrderDeliveredPayload {
  store_order_guid?: string;
  orderGuid?: string;
}

const usePostStoreOrderDelivered = (handleAfterSuccess?: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPostStoreOrderDeliveredPayload) => {
      return postStoreOrderDelivered(payload);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostStoreOrderDelivered;
